export default class CommonService {
    token = "";
    url = '';
    baseUrl = process.env.VUE_APP_URLAPI;
    constructor() {
        this.setToken();
    }

    async get() {
        if (this.token)
            this.setToken();
        var requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + this.token,
                "Accept-Language": localStorage.getItem('Public_lang') || 'ar-sa'
            },
        }
        
        this.url = `${this.baseUrl}/${this.url}`;
        try {
            
            var x = await this.CallApi(requestOptions);
            return x;
        } catch (e) {
            
            console.log(e)
        }
       
    }

    async post(data) {
        if (this.token)
            this.setToken();

        if (this.token == '')
            this.setToken();

        var requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + this.token,
                "Accept-Language": localStorage.getItem('Public_lang') || 'ar-sa'
            },            
            body: JSON.stringify(data)
        }

        this.url = `${this.baseUrl}/${this.url}`; 
       
        try {
            var x = await this.CallApi(requestOptions);
            return x;
        } catch (e) {
            
            console.log(e);
        }
    }
    async put(data) {
        if (this.token)
            this.setToken();
        var requestOptions = {
            method: "PUT",
            headers: {
                //'Content-Type': 'multipart/form-data',
                "Authorization": 'Bearer ' + this.token
            },
            body:  data 
        }
        this.url = `${this.baseUrl}/${this.url}`;
        return await this.CallApi(requestOptions);
    }
    async CallApi(requestOptions) {
       return fetch(this.url, requestOptions);
    }
    setToken() {
        var cookies = this.getCookies("SCFHSAdmin");
        if (cookies && cookies != "")
        {
            var cookiesValue = JSON.parse(cookies);
            this.token = cookiesValue.token;
        }
        return this.token;
    }
    getCookies(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}
